<template>
  <div>
    <div class="tertiary--text text-body-2">
      {{ 
        $t(
        'fleet_management.agents.agent_detail.partials.card_field_things_agents'
        )
      }}
    </div>
    <div
      v-if="!loading && !editMode && getThingsSelected.length < 1"
      class="text-body-2 py-2"
    >
      {{
        $t(
          'fleet_management.persons.person_info.labels.card_field_not_vehicles_configured'
        )
      }}
    </div>
    <div class="mt-2 mb-2" v-if="!editMode">
      <div v-if="loading" class="text-center">
        <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>
      </div>
      <div v-if="!loading">
        <v-chip
          v-for="(item, index) in getThingsSelected"
          class="mr-2 mb-2"
          v-if="index < thingsToShow"
        >
          {{ item.info.label }}
        </v-chip>
        <h4
          v-if="isAdminSubFleet && agentHasMoreThingsThanUser"
          class="red--text text-body-2 font-weight-normal"
        >
          {{ 
            $t(
            'fleet_management.agents.agent_detail.partials.message_unmanageable_vehicles'
            )
          }}
        </h4>
        <span
          class="secondary--text mr-2"
          v-if="thingsToShow < getThingsSelected.length && thingsToShow <= 10"
        >
          {{ 
            $t(
              'fleet_management.agents.agent_detail.partials.vehicles_total', { count: getThingsSelected.length }
              ) 
          }}
        </span>
        <span
          class="secondary--text mr-2"
          v-if="thingsToShow < getThingsSelected.length && thingsToShow > 10"
        >
          ( +{{ getThingsSelected.length - thingsToShow }} )
        </span>
        <v-btn
          small
          color="primary"
          text
          v-on="$listeners"
          v-if="thingsToShow < getThingsSelected.length"
          @click="showMoreZones"
        >
          <v-icon left>
            mdi-plus-circle-outline
          </v-icon>
          <span class="text-capitalize text-body-2">
            Ver más
          </span>
        </v-btn>
      </div>
    </div>
    <v-autocomplete
      v-if="editMode"
      id="idEventosEntidadesEditar"
      v-model="getThingsSelected"
      return-object
      :readonly="!editMode"
      :items="allThingsFiltered"
      multiple
      chips
      filled
      dense
      deletable-chips
      item-text="info.label"
      no-data-text="no hay info"
      :loading="loading"
      :disabled="thingsLoading"
      color="tertiary"
      :rules="selectedRules"
    >
      <template v-slot:prepend-item>
        <v-tooltip
          v-if="allThingsFiltered.length >= 2000"
          top
          content-class="secondary white--text text-subtitle-2"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-list-item
              id="idEventosEntidadesSeleccionarTodoEditar"
              v-bind="attrs"
              v-on="on"
              ripple
              @click="selectAll()"
            >
              <v-list-item-action>
                <v-icon>
                  {{ icon }}
                </v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  <span>
                    {{ 
                      $t(
                      'fleet_management.agents.agent_detail.partials.form_title_select_all'
                      )
                    }}
                  </span>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
          <span>{{
            $t('fleet_management.agents.alerts.select_all_many_entities')
          }}</span>
          <div class="tooltip-arrow"></div>
        </v-tooltip>
        <v-list-item
          id="idEventosEntidadesSeleccionarTodoEditar"
          v-else
          ripple
          @click="selectAll()"
        >
          <v-list-item-action>
            <v-icon>
              {{ icon }}
            </v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              <span>
                {{ 
                  $t(
                  'fleet_management.agents.agent_detail.partials.form_title_select_all'
                  )
                }}
              </span>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider class="mt-2"></v-divider>
      </template>
      <template v-slot:item="data" style="max-height: 50px;">
        <v-checkbox
          v-model="data.item.checked"
          :value="data.item.checked"
        ></v-checkbox>
        <span
          :id="data.item.domElementId"
          @click="data.item.checked = !data.item.checked"
          class="dropdown-element-style py-6"
        >
          {{ data.item.info.label }}
        </span>
      </template>
      <template v-slot:selection="{ item, index }">
        <v-chip v-if="index < 3">
          <span>{{ item.info.label }}</span>
        </v-chip>
        <span v-else-if="index === 3" class="grey--text caption">
          (+{{ selectedThings.length - 3 }})
        </span>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
import store from '@/store'
import { GlobalHelpers } from '@/helpers/mainExports.js'
import { mapState } from 'vuex'

export default {
  name: 'Things',
  props: {
    editMode: {
      type: Boolean,
      default: false
    },
    dataProp: {
      type: Array
    },
    conditionsForTimeComponent: {
      type: Array
    }
  },
  data() {
    return {
      dataPropThing: [],
      loading: false,
      allThings: [],
      selectedThings: [],
      selectedRules: [],
      securityServices: [
        'panic_button',
        'driver_door',
        'cargo_gate',
        'semi_detach',
        'tamper_sensor',
        'fuel_cut_off'
      ],
      genericServices: [
        'generic_unauthorized_stop',
        'generic_put_into_service',
        'generic_taken_out_of_service',
        'generic_still_detached',
        'generic_event_test',
        'seat_passenger',
        'generic_delivery',
        'sharped_turn',
        'hard_brake',
        'hard_acceleration'
      ],
      thingsToShow: 10
    }
  },
  methods: {
    showMoreZones() {
      this.thingsToShow += 10
    },
    async getThingsList() {
      this.loading = true
      const response = await GlobalHelpers.getEntities({
        projection: 'id, info.label, type, config.services'
      })
      if (response !== null && response !== undefined) {
        if (!response.hasOwnProperty('error')) {
          const things = response.map(item => {
            return item
          })
          this.allThings = things
          this.loading = false
        } else {
          this.loading = false
        }
      } else {
        this.loading = false
      }
    },
    selectAll() {
      if (this.selectedAllThings) {
        this.getThingsSelected.forEach(element => {
          element.checked = false
        })
        this.dataPropThing = []
        this.getThingsSelected = []
        this.updateThings()
      } else {
        this.dataPropThing = this.allThingsFiltered.map(e => {
          return { [e.id]: e.info.label }
        })
        this.getThingsSelected = this.allThingsFiltered
        this.dataPropThing.forEach(element => {
          element.checked = true
        })
        this.updateThings()
      }
    },
    updateThings() {
      this.selectRules()
      this.$emit('thingsEmit', this.selectedThings)
    },
    genericConditionsLabel(val) {
      const GENERIC_CONDITIONS_LABEL = {
        'mrn:agent_condition:generic_unauthorized_stop': 'Parada No Autorizada',
        'mrn:agent_condition:generic_put_into_service': 'Puesta en Servicio',
        'mrn:agent_condition:generic_taken_out_of_service': 'Quita de Servicio',
        'mrn:agent_condition:generic_still_detached': 'Todavía Desenganchado',
        'mrn:agent_condition:generic_event_test': 'Evento de prueba',
        'mrn:agent_condition:generic_seat_passenger': 'Pasajero detectado',
        'mrn:agent_condition:generic_delivery': 'Entrega',
        'mrn:agent_condition:generic_sharped_turn': 'Giro Brusco',
        'mrn:agent_condition:generic_hard_brake': 'Frenada Brusca',
        'mrn:agent_condition:generic_hard_acceleration': 'Aceleración Brusca'
      }

      return GENERIC_CONDITIONS_LABEL[val] ?? ''
    },
    genericConditionsService(val) {
      const GENERIC_CONDITIONS_SERVICE = {
        'mrn:agent_condition:generic_unauthorized_stop':
          'mrn:service:generic_unauthorized_stop',
        'mrn:agent_condition:generic_put_into_service':
          'mrn:service:generic_put_into_service',
        'mrn:agent_condition:generic_taken_out_of_service':
          'mrn:service:generic_taken_out_of_service',
        'mrn:agent_condition:generic_still_detached':
          'mrn:service:generic_still_detached',
        'mrn:agent_condition:generic_event_test':
          'mrn:service:generic_event_test',
        'mrn:agent_condition:generic_seat_passenger':
          'mrn:service:generic_seat_passenger',
        'mrn:agent_condition:generic_delivery': 'mrn:service:generic_delivery',
        'mrn:agent_condition:generic_sharped_turn': 'mrn:service:generic_sharped_turn',
        'mrn:agent_condition:generic_hard_brake': 'mrn:service:generic_hard_brake',
        'mrn:agent_condition:generic_hard_acceleration': 'mrn:service:generic_hard_acceleration'
      }

      return GENERIC_CONDITIONS_SERVICE[val] ?? ''
    },
    securityCondition(val) {
      switch (val) {
        case 'mrn:agent_condition:panic_button':
          return 'Pánico'
        case 'mrn:agent_condition:driver_door':
          return 'Apertura de puerta'
        case 'mrn:agent_condition:cargo_gate':
          return 'Apertura de portón de carga'
        case 'mrn:agent_condition:semi_detach':
          return 'Desenganche'
        case 'mrn:agent_condition:tamper_sensor':
          return 'Antivandálico vulnerado'
        case 'mrn:agent_condition:fuel_cut_off':
          return 'Corte combustible'
        default:
          return undefined
      }
    },
    selectRules() {
      const conditions = this.conditionsForTimeComponent
        .map(condition => condition.slice('mrn:agent_condition:'.length))
        .filter(condition => this.securityServices.includes(condition))

      const services = conditions.map(condition => `mrn:service:${condition}`)
      const genericService = this.genericConditionsService(
        this.conditionsForTimeComponent[0]
      )

      genericService && services.push(genericService)

      const rules = []
      this.selectedThings.map(thing => {
        services.forEach(service => {
          if (
            !thing.config.hasOwnProperty('services') ||
            !thing.config.services.hasOwnProperty(service) ||
            thing.config.services[service].status === 'suspended'
          ) {
            rules.push({
              name: thing.info.label,
              condition: service
            })
          }
        })
      })

      let resultRules = true
      // unifica las array en un objeto para retornar el rules con los things no soportados

      if (rules && rules.length > 0) {
        const rulesResult = { label: '', condition: '', length: 0 }

        rules.map(rule => {
          rulesResult.label = `${rulesResult.label} ${rule.name}, `
          rulesResult.length++
          rulesResult.condition =
            this.securityCondition(
              'mrn:agent_condition:' +
                rule.condition.slice('mrn:service:'.length)
            ) ?? this.genericConditionsLabel(conditions[0])
        })

        resultRules = `La${rulesResult.length > 1 ? 's' : ''} entidad${
          rulesResult.length > 1 ? 'es' : ''
        } ${
          rulesResult.label
        } no tienen contratado el servicio para generar este evento.`
      }
      this.selectedRules = [resultRules]
    }
  },
  computed: {
    ...mapState('auth', ['session']),
    isAdminSubFleet() {
      return store.getters.isAdminSubFleet
    },
    allThingsFiltered() {
      if (!this.hasSuspendedEntitiesConfigured) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.allThings = this.allThings.filter(
          thing =>
            thing.config?.services?.['mrn:service:live_tracking'] &&
            thing.config?.services?.['mrn:service:live_tracking']?.status !== 'inactive' &&
            thing.config?.services?.['mrn:service:live_tracking']?.status !==
            'suspended'
        )
      }
      const thingsFiltered = this.lowBattery
        ? this.allThings.filter(thing => thing.type === 'mrn:thing:flex')
        : this.isRalenti || this.isFuelConsumptionDeviation || 
          this.isFuelCharge || this.isEngineTemperature ||
          this.isRpmExcessive
        ? this.allThings.filter(thing =>
            Object.keys(thing.config.services).find(
              service => service === 'mrn:service:telemetry'
            )
          )
        : this.allThings
      for (let index = 0; index < thingsFiltered.length; index++) {
        thingsFiltered[index]['domElementId'] = `idEventosEntidad${index}`
      }
      return thingsFiltered
    },
    hasSuspendedEntitiesConfigured() {
      return this.getThingsSelected.some(
        thing =>
          thing.config?.services?.['mrn:service:live_tracking']?.status ===
          'suspended'
      )
    },
    selectedAllThings() {
      return this.dataPropThing.length === this.allThingsFiltered.length
    },
    selectedSomeThings() {
      return this.selectedThings.length > 0 && !this.selectedAllThings
    },
    icon() {
      if (this.selectedAllThings) return 'mdi-close-box'
      if (this.selectedSomeThings) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    },
    getThingsSelected: {
      get() {
        if (this.agentHasMoreThingsThanUser) {
          return this.dataPropThing.map(obj => ({
            id: Object.keys(obj)[0],
            info: {
              label: obj[Object.keys(obj)[0]]
            },
            checked: true
          }))
        } else {
          const result = this.allThings.filter(item =>
            this.dataPropThing.some(thing => item.id == Object.keys(thing)[0])
          )
          for (let index = 0; index < result.length; index++) {
            result[index].checked = true
          }
          return result
        }
      },
      set(value) {
        this.selectedThings = value
        this.updateThings()
      }
    },
    agentHasMoreThingsThanUser() {
      const allInAllThings = this.dataPropThing.every(thing =>
        this.allThings.some(item => item.id === Object.keys(thing)[0])
      )

      return !allInAllThings
    },
    lowBattery() {
      return this.conditionsForTimeComponent.find(
        thing => thing === 'mrn:agent_condition:low_battery'
      )
    },
    isRalenti() {
      return this.conditionsForTimeComponent.find(
        thing => thing === 'mrn:agent_condition:ralenti'
      )
    },
    isFuelConsumptionDeviation() {
      return this.conditionsForTimeComponent.find(
        thing => thing === 'mrn:agent_condition:fuel_consumption_deviation'
      )
    },
    isFuelCharge() {
      return this.conditionsForTimeComponent.find(
        thing => thing === 'mrn:agent_condition:fuel_charge'
      )
    },
    isEngineTemperature() {
      return this.conditionsForTimeComponent.find(
        thing => thing === 'mrn:agent_condition:engine_temperature'
      )
    },
    isRpmExcessive() {
      return this.conditionsForTimeComponent.find(
        thing => thing === 'mrn:agent_condition:excessive_rpm'
      )
    },
  },
  watch: {
    async session(newSession) {
      //En caso que al inicio no hubiera una sesión abierta, observamos su estado
      //y cuando la misma este disponible obtenemos los datos
      //Escenario de uso: frente a un reload de página
      if (newSession.isOpen) {
        await this.getThingsList()
        this.updateThings()
      }
    },
    editMode() {
      if (this.editMode == false) {
        this.selectedThings.forEach(element => {
          element.checked = false
        })
        this.selectedThings = []
        this.selectedRules = []

        this.dataProp.map(item => {
          const id = Object.keys(item)[0]
          const data = this.allThings.find(thing => thing.id === id)
          if (data !== undefined) {
            data.checked = true
            this.selectedThings.push(data)
          }
        })
      }
    },
    dataProp(value) {
      this.dataPropThing = value
    },
    getThingsSelected(value) {
      this.selectedThings = value
    },
    agentHasMoreThingsThanUser(value) {
      this.$root.$emit('agentHasMoreThanUser', value)
    }
  },
  async created() {
    if (this.session.isOpen) {
      await this.getThingsList()
      this.updateThings()
    }
  }
}
</script>

<style lang="scss" scoped>
.dropdown-element-style {
  color: #2b2b2b;
  font-family: Lato, sans-serif;
  font-size: 13px;
  width: 100%;
}
</style>
